// react
import React, { useEffect, useState } from "react";
import { BeatLoader } from "react-spinners";
import { useLocation } from "react-router-dom";

// css
import "./elderLog.css";
import styles from './elderLog.module.css';

// service
import { gathDataExcelDownLoad, getChartData, getGridData, getRawAvgData, getRawChart, getRawRecentData } from "../../../service/log/elderLogService";
import ElderLogDashboard from "./elderLogDashboard";
import ElderLogChart from "./elderLogChart";
import ElderLogGrid from "./elderLogGrid";
import ElderLogSearch from "./elderLogSearch";
import { getElderInfo, getUserStat } from "../../../service/mngt/elderService";
import { getUser } from "../../../service/authService";
import { ImportExport } from "@material-ui/icons";

const ElderLog = ({ conn, qs, codeList, dongList }) => {
  const [loading, setLoading] = useState(false);
  const locationState = useLocation().state;
  const userInfo = getUser();
  
  // 이벤트 안내 창 상태
  const [infoEventWindow, setInfoEventWindow] = useState(false);

  // 차트 / 표 구분
  const [display, setDisplay] = useState(false);

  // 어제 날짜
  const today = new Date();

  // 검색 조건
  const [search, setSearch] = useState({
    // rgnCode: getUser().rgnCode,
    // dongCode: "",
    // userId: "",
    // userTerm: "",
    startDtm: today,
    endDtm: today,
    radio: "HH",

    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },
  });

  // 페이징
  const [page, setPage] = useState({
    skip: 0,
    take: 20,
  });

  const [elderInfo, setElderInfo] = useState({});
  const [userStat, setUserStat] = useState({});

  // 데이터 소스
  const [dataSource, setDataSource] = useState({
    chartData: [],
    movementDs: [],
    breathCntDs: [],
    temperatureDs: [],
    humidityDs: [],
    lightDs: [],
    highActivityCntDs: [],
    lowActivityCntDs: [],
    sleepCntDs: [],
    deepSleepCntDs: [],
    eatCntDs: [],
    noneCntDs: [],
    co2Ds: [],
    gridDs: [],
    total: 0,
    gridNoMessage: " ",
    avgCO2: 0,
    avgMovement: 0,
    avgTemperature: 0,
    avgHumidity: 0,
    avgLight: 0,
    avgBreathCnt: 0,
    recentCO2: 0,
    recentMovement: 0,
    recentTemperature: 0,
    recentHumidity: 0,
    recentLight: 0,
    recentBreathCnt: 0,
  });

  // 페이징 함수
  const setPageValue = e => {
    page.skip = e.page.skip;
    page.take = e.page.take;
    getGridDataSource();
  };

  // 엑셀 다운로드 이벤트
  const excelDown = () => {
    setLoading(true);
    gathDataExcelDownLoad(search, setLoading);
  };

  // 차트, 표 변경 
  const changeDisplay = (e) => {
    if(display) {
      setDisplay(false);
    } else {
      setDisplay(true);
    }
  }

  
  // 그리드 데이터
  const getGridDataSource = () => {
    setLoading(true);
    Promise.all([getGridData(conn, setGridDataSource, getRejection, search, page)]).then(() => {
      setLoading(false);
    });
  };

  //Grid callback
  const setGridDataSource = result => {
    result.results.map(item => {
      if(item.eventType === 11001) {
        item.eventTypeTerm = "긴급버튼";
      } else {
        item.eventTypeTerm = "-";
      }
      if(item.bizType === "5002") {
        item.co2 = "-";
        item.tvoc = "-";
      }
      // item.eventTypeTerm = item.eventType != "-" ? codeList.filter(c => c.codeNo === item.eventType && c.grpCodeNo === 11)[0].codeVal : "-";
      item.lightTerm = item.light != "-" && item.light === 1 ? "감지" : "미감지";
    });
    setDataSource(dataSource => {
      const item = { ...dataSource };
      item.gridDs = result.results;
      item.total = result.total;
      item.gridNoMessage = "조회 결과 데이터가 없습니다.";
      return item;
    });
  };

  // chart Call back
  const setChartData = result => {
    setDataSource(dataSource => {
      const item = { ...dataSource };
      item.movementDs = result.movementDs;
      item.breathCntDs = result.breathCntDs;
      item.temperatureDs = result.temperatureDs;
      item.humidityDs = result.humidityDs;
      item.lightDs = result.lightDs;
      item.highActivityCntDs = result.highActivityCntDs;
      item.lowActivityCntDs = result.lowActivityCntDs;
      item.sleepCntDs = result.sleepCntDs;
      item.deepSleepCntDs = result.deepSleepCntDs;
      item.eatCntDs = result.eatCntDs;
      item.noneCntDs = result.noneCntDs;
      item.co2Ds = result.co2Ds;
      return item;
    });
  };

  // raw avg data callback
  const setRawAvgData = result => {
    setDataSource(dataSource => {
      const item = { ...dataSource };
      item.avgCO2 = result.co2;
      item.avgMovement = result.movement;
      item.avgTemperature = result.temperature;
      item.avgHumidity = result.humidity;
      item.avgLight = result.light;
      item.avgBreathCnt = result.breathCnt;
      return item;
    });
  }

  // raw recent data callback
  const setRawRecentData = result => {
    setDataSource(dataSource => {
      const item = { ...dataSource };
      item.recentCO2 = result.co2;
      item.recentMovement = result.movement;
      item.recentTemperature = result.temperature;
      item.recentHumidity = result.humidity;
      item.recentLight = result.light;
      item.recentBreathCnt = result.breathCnt;
      return item;
    });
  }

  const setElder = result => {
    setElderInfo(result);
  };

  // rejection
  const getRejection = error => {
    console.log("error = ", error);
  };

  // searchData
  const getDataSourceEvt = () => {
    setLoading(true);
    Promise.all([
      getData(),
      getRawChart(conn, search),
      // getChartData(conn, setChartData, getRejection, search),
      getGridData(conn, setGridDataSource, getRejection, search, page),
      // getRawAvgData(conn, setRawAvgData, getRejection, search),
      // getRawRecentData(conn, setRawRecentData, getRejection, search),
      getElderInfo(conn, setElder, getRejection, search),
    ])
      .then((result) => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.chartData = result[1];
          return item;
        })
        setLoading(false);
      })
      .catch(error => console.log("error", error));
  };

  const getData = () => {
    getUserStat(conn, search)
    .then(result => {
      setUserStat(result);
    })
    .catch(err => {
      console.log("err = ", err);
    })
  }

  useEffect(() => {
    // getData();
    // getDataSourceEvt();
  }, []);

  return (
    <>
      <div
        className="elderLogContents"
        style={
          loading
            ? {
                opacity: 0.6,
                pointerEvents: "none",
              }
            : null
      }>
        <ElderLogSearch
          conn={conn}
          dongList={dongList}
          search={search}
          getDataSourceEvt={getDataSourceEvt}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          locationState={locationState}
          elderInfo={elderInfo}
        />
        <ElderLogDashboard 
          conn={conn}
          dataSource={dataSource}
          page={page}
          setPageValue={setPageValue}
          search={search}
          infoEventWindow={infoEventWindow}
          setInfoEventWindow={setInfoEventWindow}
          setLoading={setLoading}
          userStat={userStat}
        />
        {!display ? 
        <>
          <div className={styles.elderLogTitle}>
            <span>데이터 수집 차트</span>
            <div>
              <button onClick={changeDisplay}>표로 보기</button>
            </div>
          </div>
          <ElderLogChart search={search} dataSource={dataSource} elderInfo={elderInfo} />
        </>
        :
        <>
          <div className={styles.elderLogTitle}>
            <span>데이터 수집 표</span>
            <div>
              <button style={{background: "#3777aa"}} onClick={excelDown}>엑셀 저장</button>
              <button onClick={changeDisplay}>차트로 보기</button>
            </div>
          </div>
          <ElderLogGrid
            dataSource={dataSource}
            page={page}
            setPageValue={setPageValue}
            search={search}
            infoEventWindow={infoEventWindow}
            setInfoEventWindow={setInfoEventWindow}
            setLoading={setLoading}
          />
        </>
        }
      </div>
      {loading && (
        <p
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </>
  );
};

export default ElderLog;
